var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "#1D3445",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.66536 13.3337C2.2987 13.3337 1.98481 13.2031 1.7237 12.942C1.46259 12.6809 1.33203 12.367 1.33203 12.0003V4.00033C1.33203 3.63366 1.46259 3.31977 1.7237 3.05866C1.98481 2.79755 2.2987 2.66699 2.66536 2.66699H13.332C13.6987 2.66699 14.0126 2.79755 14.2737 3.05866C14.5348 3.31977 14.6654 3.63366 14.6654 4.00033V12.0003C14.6654 12.367 14.5348 12.6809 14.2737 12.942C14.0126 13.2031 13.6987 13.3337 13.332 13.3337H2.66536ZM7.9987 8.55033C8.05425 8.55033 8.11259 8.54199 8.1737 8.52533C8.23481 8.50866 8.29314 8.48366 8.3487 8.45033L13.0654 5.50033C13.1543 5.44477 13.2209 5.37533 13.2654 5.29199C13.3098 5.20866 13.332 5.11699 13.332 5.01699C13.332 4.79477 13.2376 4.6281 13.0487 4.51699C12.8598 4.40588 12.6654 4.41144 12.4654 4.53366L7.9987 7.33366L3.53203 4.53366C3.33203 4.41144 3.13759 4.40866 2.9487 4.52533C2.75981 4.64199 2.66536 4.80588 2.66536 5.01699C2.66536 5.1281 2.68759 5.22533 2.73203 5.30866C2.77648 5.39199 2.84314 5.45588 2.93203 5.50033L7.6487 8.45033C7.70425 8.48366 7.76259 8.50866 7.8237 8.52533C7.88481 8.54199 7.94314 8.55033 7.9987 8.55033Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIcon);
export default __webpack_public_path__ + "static/media/emailIcon.2bc361ec54f240cbb9d98068cce88858.svg";
export { ForwardRef as ReactComponent };